import React from 'react';
import ServicePage from '../../components/site/ServicePage';
import { AGENT_FAQS as FAQS } from '../../site/faqs';
import { CONTACT } from '../../site/nav';

export default function WebsiteAgent() {
  return (
    <ServicePage
      path="/website-agent"
      eyebrow="AI designer"
      title="A designer on your ecommerce site, all day."
      lead="The designer goes on top of the ecommerce site you already run. It knows every product, sells by voice or text, and knows when to hand off to a person or capture the lead."
      proof={{ label: 'Watch it sell on eastbay.direct', href: CONTACT.liveSite }}
      features={[
        { title: 'Voice and text', text: 'Shoppers tap a mic or type.' },
        { title: 'Knows the whole catalog', text: 'Price, size, colour, material, stock, and what goes together.' },
        { title: 'Acts on the page', text: 'Filters, opens products, compares, saves, and adds to the cart.' },
        { title: 'Knows when to hand off', text: 'When the shopper asks for a person or is ready to buy, it offers a call or captures the lead with the piece attached.' },
        { title: 'Follows your policies', text: 'Financing, returns, price match, and stock are answered your way.' },
        { title: 'Improves on your catalog', text: 'Every conversation is reviewed so the agent gets better at your products.' },
      ]}
      customer={{
        title: 'Built for three kinds of store',
        items: [
          { title: 'Showrooms adding ecommerce', text: 'The site sells with the same catalog as the floor.' },
          { title: 'Ecommerce only', text: 'No showroom. The agent answers and sells 24 hours a day.' },
          { title: 'National brands', text: 'We put the designer on your site and connect it to your product feed.' },
        ],
      }}
      steps={[
        { title: 'Connect your product feed', text: 'Prices, photos, dimensions, stock, and categories.' },
        { title: 'Set the rules', text: 'Your policies, your delivery area, and when it hands off.' },
        { title: 'The designer goes live on your pages', text: 'Your checkout does not change.' },
      ]}
      faqs={FAQS}
      closing={{ title: 'See it on your pages.', text: 'Bring your product feed to the demo.' }}
    />
  );
}
